module.exports = __webpack_public_path__ + "static/media/kwara-logo-png.08466210.png";